import { z } from 'zod';
import { apiClient } from '@/api/api-client';

export const adminLanguageScopeSchema = z.object({
  all: z.boolean(),
  languages: z.array(z.string().min(1)).max(500),
  collectorLanguages: z.array(z.string().min(1)).max(500).optional(),
  adminLanguages: z.array(z.string().min(1)).max(500).optional(),
  collectorAccessLanguages: z.array(z.string().min(1)).max(500).optional(),
});

const adminLanguageScopeResponseSchema = z.object({
  status: z.literal(200),
  error: z.literal(false),
  message: z.literal('ADMIN_LANGUAGE_SCOPE_READ'),
  data: adminLanguageScopeSchema,
});

export type AdminLanguageScope = z.infer<typeof adminLanguageScopeSchema>;

export const adminScopeApi = {
  /** Languages the signed-in admin may read across the admin space. */
  async getLanguageScope(signal?: AbortSignal): Promise<AdminLanguageScope> {
    const response = await apiClient.get<unknown>('/admin/language-scope', {
      signal,
    });
    return adminLanguageScopeResponseSchema.parse(response.data).data;
  },
};
